import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Favorite} from '@models/favorite';
import {UntypedFormControl} from '@angular/forms';
import {HttpClient} from '@angular/common/http';
import {CommonService} from '@services/common.service';
import {NoopScrollStrategy} from '@angular/cdk/overlay';
import {MatDialog} from '@angular/material/dialog';
import {DpeComponent as popup} from '@components/popup/dpe/dpe.component';

@Component({
  selector: 'app-dpe',
  templateUrl: './dpe.component.html',
  styleUrls: ['./dpe.component.scss']
})
export class DpeComponent implements OnInit {

    @Input() favorite: any;
    @Input() extChange = new EventEmitter();
    // panelColor = new UntypedFormControl('');
    energy_rate: string;
    energy_rate_value: string;
    show_popup = false;

    constructor(
        private http: HttpClient,
        public commonService: CommonService,
        public dialog: MatDialog,
    ) {
    }

    ngOnInit(): void {
        if (this.extChange) {
            this.extChange.subscribe(data => {
                this.setData();
            });
        }
        this.setData();
        // this.panelColor.setValue(this.favorite.status);
    }
    setData(){
        if (this.favorite instanceof Object) {
            this.energy_rate = this.favorite.energy_rate;
            this.energy_rate_value = this.favorite.energy_rate_value;
            this.show_popup = true;
        } else {
            this.energy_rate = this.favorite;
        }
    }

    popup() {
        const dialogRef = this.dialog.open(popup, {
            width: '1000px',
            scrollStrategy: new NoopScrollStrategy()
        });
    }
}
